module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0066.jpg?v=0f0b2eb6";